import { useContext } from "react"

import { AnalyticsContext } from "@mkt/utils/contexts"

export default function useAnalytics() {
  const contextData = useContext(AnalyticsContext)

  return contextData
}
